import { ClientApplication, createApp } from "@shopify/app-bridge"
import { Redirect } from "@shopify/app-bridge/actions"
import { isShopifyEmbedded as _isShopifyEmbedded } from "@shopify/app-bridge-utils/utilities/platform"

const urlSearchParams = new URLSearchParams(window.location.search)

window.ManageParams = {
  "auth-token": urlSearchParams.get("auth-token") || "",
  // @ts-ignore
  display_intercom: urlSearchParams.get("display_intercom") || "false",
  from: urlSearchParams.get("from") || "",
}

export function isAdmin() {
  return (window as any).ManageParams.from === "admin"
}

export function isShopifyEmbedded() {
  return !isAdmin() && _isShopifyEmbedded()
}

export default class AppBridge {
  public static app: ClientApplication<any>
  public static redirect: Redirect.Redirect
  public static get shopify() {
    return { 
      scopes: {
        request: this.requestScopes,
        revoke: this.revokeScopes,
      },
    }
  }

  /**
   * 判断是否存在该实例
   */
  static exist() {
    return this.app !== undefined
  }

  static set(host: string) {
    const apiKey = import.meta.env.VITE_SHOPIFY_APP_KEY || ""

    this.app = createApp({ apiKey, host })

    if (!this.redirect) {
      this.redirect = Redirect.create(this.app)
    }


    return this.app
  }

  /**
   * 请求 Shopify 权限范围
   * @param scopes 权限范围数组
   * @returns Promise<{result: string}> 权限请求结果
   */
  static async requestScopes(scopes: string[]): Promise<{result: string}> {
    if (typeof window !== "undefined" && (window as any).shopify?.scopes?.request) {
      try {
        return await (window as any).shopify.scopes.request(scopes)
      } catch (error) {
        console.error("Failed to request scopes:", error)
        return { result: "declined-all" }
      }
    }
    console.warn("Shopify scopes API not available")
    return { result: "declined-all" }
  }

  // 撤销权限
  static async revokeScopes(scopes: string[]): Promise<{result: string}> {
    return await (window as any).shopify.scopes.revoke(scopes)
  }
}


const getAppBase = () => import.meta.env.VITE_BASE_URL || "/"

const getAppLink = (path: string = "/") => {
  const link = `${getAppBase()}${path}`

  return link.replaceAll("//", "/")
}

export {
  getAppBase,
  getAppLink,
}
